export default "__VITE_ASSET__0d708488__"